import { Close, Search } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

interface Props {
  handleSearch: (text: string) => void;
}

const SearchAssociations = (props: Props) => {
  const { handleSearch } = props;
  const [enteredText, setEnteredText] = useState("");

  useEffect(() => {
    const searchTimeout = setTimeout(() => {
      handleSearch(enteredText);
    }, 1000);

    return () => clearTimeout(searchTimeout);
  }, [enteredText, handleSearch]);

  const onInputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEnteredText(event.target.value);
  };

  return (
    <TextField
      value={enteredText}
      onChange={onInputChanged}
      label="Procurar"
      InputProps={{
        endAdornment: (
          <IconButton
            onClick={() => setEnteredText("")}
            disabled={!enteredText}
          >
            {enteredText ? <Close /> : <Search />}
          </IconButton>
        ),
      }}
    />
  );
};

export default SearchAssociations;
